import type {
  IntegrationCrmSettings,
  IntegrationItem,
  IntegrationStatus,
  MaxSettings,
} from '@/api/integrations/integrations.types'
import { buildMaxBotUrl } from '@/helpers/notificationIntegration'
import {
  canConnectVkCrmIntegration,
  createDefaultVkCrmSettings,
  getIntegrationsListErrorText,
  isMaskedSecret,
  MASKED_SECRET_PLACEHOLDER,
  getCredentialInputValue,
  mergeVkCrmSettingsForSave,
  normalizeIntegrationTrafficChannelId,
  VK_CRM_STATUS_LABELS,
  VK_CRM_USAGE,
} from '../../VkCrmCommunitiesSettings/lib/vkCrmIntegration.helpers'

export const MAX_CRM_USAGE = VK_CRM_USAGE

export const MAX_CRM_STATUS_LABELS = VK_CRM_STATUS_LABELS

export const canConnectMaxCrmIntegration = canConnectVkCrmIntegration
export const createDefaultMaxCrmSettings = createDefaultVkCrmSettings
export const mergeMaxCrmSettingsForSave = mergeVkCrmSettingsForSave
export {
  getIntegrationsListErrorText,
  isMaskedSecret,
  MASKED_SECRET_PLACEHOLDER,
  getCredentialInputValue,
}

export const isMaxCrmIntegration = (item: IntegrationItem): boolean => {
  const usages = item.usages
  if (!Array.isArray(usages) || usages.length === 0) return true
  if (usages.includes(MAX_CRM_USAGE)) return true
  const notificationOnly = usages.every(
    (usage) =>
      usage === 'notifications' ||
      usage === 'password_reset' ||
      usage === 'mailing' ||
      usage === 'support',
  )
  return !notificationOnly
}

export const filterMaxCrmIntegrations = (
  items: IntegrationItem[] | null | undefined,
): IntegrationItem[] => {
  if (!Array.isArray(items)) return []
  return items.filter(isMaxCrmIntegration)
}

export const getMaxBotId = (
  item: IntegrationItem | null | undefined,
): string => {
  if (!item) return ''
  const fromCredentials = item.credentials?.bot_id
  if (fromCredentials != null && String(fromCredentials).trim()) {
    return String(fromCredentials).trim()
  }
  return ''
}

export const getMaxBotPublicUrl = (
  item: IntegrationItem | null | undefined,
): string | null => buildMaxBotUrl(getMaxBotId(item))

export const readMaxCrmSettings = (
  item: IntegrationItem | null | undefined,
): IntegrationCrmSettings => {
  const crm = (item?.settings as MaxSettings | undefined)?.crm
  return createDefaultVkCrmSettings({
    funnel_id: crm?.funnel_id ?? null,
    traffic_channel_id: normalizeIntegrationTrafficChannelId(
      crm?.traffic_channel_id,
    ),
    create_lead: crm?.create_lead ?? true,
    create_chat: crm?.create_chat ?? true,
    lead_fields:
      crm?.lead_fields && Array.isArray(crm.lead_fields) ? crm.lead_fields : [],
    access: {
      roles: crm?.access?.roles ?? [],
      departments: crm?.access?.departments ?? [],
    },
  })
}

export type { IntegrationStatus }
